export const AUTO_DISMISS = 5;
